<app-filter-card
  i18n-heading
  heading="Reklamationsfilter"
  testId="order-claim-filter"
  [canReset]="isFiltered"
  (reset)="resetFilter()"
>
  <app-date-range-filter
    testId="order-claim-filter-date"
    [(from)]="filter.dateFrom"
    [(to)]="filter.dateTo"
    (rangeChange)="refresh()"
  ></app-date-range-filter>

  <div class="col-12 col-md-3">
    <!-- Spacer label so the checkboxes align with the date fields; hidden on stacked layout. -->
    <label class="form-label d-none d-md-block" aria-hidden="true">&nbsp;</label>
    <div class="d-flex align-items-center gap-3" style="min-height: var(--ts-control-height)">
      <div class="form-check mb-0">
        <input
          id="showCancellationPending"
          class="form-check-input"
          data-testid="order-claim-filter-pending-checkbox"
          type="checkbox"
          [(ngModel)]="filter.cancellationPending"
          (ngModelChange)="oncancellationPendingChanged($event)"
        />
        <label for="showCancellationPending" class="form-check-label" i18n>Offen</label>
      </div>
      <div class="form-check mb-0">
        <input
          id="showCancelled"
          class="form-check-input"
          data-testid="order-claim-filter-approved-checkbox"
          type="checkbox"
          [(ngModel)]="filter.cancelled"
          (ngModelChange)="onCancelledChanged($event)"
        />
        <label for="showCancelled" class="form-check-label" i18n>Genehmigt</label>
      </div>
    </div>
  </div>
</app-filter-card>
